var map = {
	"./CM.png": 8530,
	"./CPO.png": 132,
	"./awards.png": 904,
	"./bgSS.png": 2093,
	"./bgfoot.png": 1103,
	"./bggenai.png": 1269,
	"./bgsd.png": 2875,
	"./buybarg.png": 9476,
	"./cm_title_category.png": 6049,
	"./csv.png": 2963,
	"./dos.png": 1696,
	"./eb.png": 4726,
	"./generatebutton.png": 1921,
	"./gs.png": 5578,
	"./ior.png": 3382,
	"./mainbg1.png": 9126,
	"./robo.png": 4168,
	"./source.png": 7722,
	"./supbarg.png": 3274,
	"./supro.png": 641,
	"./uploadicon.png": 8251,
	"./xlsx.png": 1997
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;